export default __webpack_public_path__ + "static/05-222530ae8bd4c519a970c1c9e036afe5.jpg";